import BUNDLE_QUANTITY_MODAL from '../actionTypes/BundleQuantityModalActionTypes';

function BundleQuantityModalReducer(state = {}, { type, payload }) {
    switch (type) {
        case BUNDLE_QUANTITY_MODAL: {
            return { ...state, ...payload };
        }
        default:
            return state;
    }
}

BundleQuantityModalReducer.reducerName = 'bundleQuantityModal';
export default BundleQuantityModalReducer;
